/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiSmsDeliveryStatusFromJSON, StreemApiSmsDeliveryStatusToJSON, } from './';
export function StreemApiGetInvitationSmsStatusesResponseFromJSON(json) {
    return StreemApiGetInvitationSmsStatusesResponseFromJSONTyped(json, false);
}
export function StreemApiGetInvitationSmsStatusesResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'smsDeliveryStatuses': !exists(json, 'sms_delivery_statuses') ? undefined : (json['sms_delivery_statuses'].map(StreemApiSmsDeliveryStatusFromJSON)),
    };
}
export function StreemApiGetInvitationSmsStatusesResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'sms_delivery_statuses': value.smsDeliveryStatuses === undefined ? undefined : (value.smsDeliveryStatuses.map(StreemApiSmsDeliveryStatusToJSON)),
    };
}
//# sourceMappingURL=StreemApiGetInvitationSmsStatusesResponse.js.map